export default "__VITE_ASSET__C5P2931Y__"